export default __webpack_public_path__ + "static/media/finger_lickin.fc21c805.svg";